import { render, staticRenderFns } from "./InformationPage.vue?vue&type=template&id=6499ac7c&"
import script from "./InformationPage.vue?vue&type=script&lang=js&"
export * from "./InformationPage.vue?vue&type=script&lang=js&"
import style0 from "./InformationPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports